<template>
  <md-button v-if="isVisible" :class="buttonClass" @click="add">
    <md-tooltip>{{ tooltip }}</md-tooltip>
    <md-icon>add_box</md-icon>
  </md-button>
</template>

<script>
export default {
  name: "add-button",
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    tooltip: {
      type: String,
      default: "Add"
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    role: {
      type: Number,
      default: undefined,
      validator: function(value) {
        return [4].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    isVisible() {
      if (!this.$auth.isInGlobalRole()) {
        if (!this.$auth.isInRole(this.role)) return false;
        else return this.visible;
      } else return this.visible;
    },
    buttonClass() {
      return !this.isSmall
        ? "md-primary md-just-icon add-button"
        : "md-primary md-just-icon";
    }
  },
  methods: {
    add() {
      this.$emit("add-click");
    }
  }
};
</script>

<style>
.add-button {
  float: right;
  margin-top: 10px !important;
}
</style>
